/** „123456“ → „123 456“ (Spec Kap. 5 Punkt 2). Andere Längen werden in Dreiergruppen geteilt. */
export function formatCode(code: string): string {
  const digits = code.replace(/\s+/g, '');
  return digits.replace(/(\d{3})(?=\d)/g, '$1 ');
}

/** Restzeit in Millisekunden → „m:ss“, nie negativ. */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
